/**
 * @type {Object}
 * @property {array}  data  Product data
 */
const initialState = {
    cashBoxData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerCashBox = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_CASH_BOX_DATA':
            var { data } = action;
            newState.cashBoxData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerCashBox;